import { useNavigate } from "react-router-dom";

const ACTIONS = [
    {
        to: "/damage-entry",
        label: "Damage entry",
        hint: "Record damaged stock",
        tint: "#FEF1F0",
        border: "#F8C9C5",
        color: "#D92D20",
        icon: (
            <path d="M12 3 2 20h20L12 3Zm0 7v4m0 3h.01" />
        ),
    },
    {
        to: "/stock-report",
        label: "Stock report",
        hint: "Available stock",
        tint: "#E9F4F9",
        border: "#CFE6EF",
        color: "#04698F",
        icon: (
            <path d="M4 20V10m6 10V4m6 16v-7m4 7H2" />
        ),
    },
];

// Two shortcut cards for Home. Place it right under the sticky header.
export default function QuickActions() {
    const navigate = useNavigate();

    return (
        <div className="grid grid-cols-2 gap-3">
            {ACTIONS.map((action) => (
                <button
                    key={action.to}
                    type="button"
                    onClick={() => navigate(action.to)}
                    className="xl-body text-left rounded-[18px] border px-3.5 py-3 flex items-center gap-3 active:scale-[0.97] transition"
                    style={{ background: action.tint, borderColor: action.border }}
                >
                    <span className="w-10 h-10 shrink-0 rounded-[13px] bg-white flex items-center justify-center" style={{ color: action.color }}>
                        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            {action.icon}
                        </svg>
                    </span>
                    <span className="min-w-0">
                        <span className="block text-[13px] font-bold text-[#08213D] leading-tight">{action.label}</span>
                        <span className="block text-[10.5px] font-medium text-[#5B6B7C] mt-0.5 truncate">{action.hint}</span>
                    </span>
                </button>
            ))}
        </div>
    );
}